import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, ZapIcon, FilterIcon, CalendarCheckIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    icon: UsersIcon,
    title: 'Llegan Tus Prospectos',
    desc: 'Desde anuncios, formularios, redes sociales o referidos.'
  }, {
    num: '02',
    icon: ZapIcon,
    title: 'CONECKTA Responde',
    desc: 'Respuesta automática y personalizada en segundos.'
  }, {
    num: '03',
    icon: FilterIcon,
    title: 'Se Califican',
    desc: 'Preguntas inteligentes que filtran compradores serios.'
  }, {
    num: '04',
    icon: CalendarCheckIcon,
    title: 'Cita Agendada',
    desc: 'Aparecen en tu calendario automáticamente.'
  }];
  return <section className="py-24 bg-navy relative" data-id="element-81">
      <div className="max-w-7xl mx-auto px-6" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-84">
            ¿Cómo Funciona?
          </h2>
        </motion.div>

        <div className="relative" data-id="element-85">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-[2px] bg-gradient-to-r from-transparent via-border to-transparent z-0" data-id="element-86" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6 relative z-10" data-id="element-87">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="flex flex-col items-center text-center group" data-id="element-88">
                <div className="w-24 h-24 rounded-2xl bg-surface border border-border flex items-center justify-center mb-6 relative group-hover:border-primary/50 group-hover:shadow-[0_0_20px_rgba(59,130,246,0.2)] transition-all duration-300" data-id="element-89">
                  <span className="absolute -top-3 -left-3 text-2xl font-black text-primary bg-navy px-2" data-id="element-90">
                    {step.num}
                  </span>
                  <step.icon className="w-10 h-10 text-gray-300 group-hover:text-primary transition-colors" data-id="element-91" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-92">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed max-w-[250px]" data-id="element-93">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}